module.exports = __webpack_public_path__ + "fonts/fa-light-300.b3344966.woff2";